module.exports = __webpack_public_path__ + "img/744.f266a83c.jpg";